import React from 'react'

import { CustomTable, TableTextSection } from './style'

export default function StatusTable({ data }) {
  const dataSource =
    data?.interview_workflow?.rounds?.length > 0
      ? data?.interview_workflow?.rounds
      : []

  const columns = [
    {
      title: 'Round Number',
      dataIndex: 'order',
      key: 'order',
      render: text => {
        return (
          <TableTextSection style={{ width: '140px' }}>
            {text ?? '-'}
          </TableTextSection>
        )
      },
    },
    {
      title: 'Round Name',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      render: text => {
        return (
          <TableTextSection style={{ width: '140px' }}>{text}</TableTextSection>
        )
      },
    },
    {
      title: 'Status',
      dataIndex: 'driveStatus',
      key: 'roundStatus',
      render: text => {
        return (
          <TableTextSection style={{ width: '140px' }}>{text}</TableTextSection>
        )
      },
    },
  ]

  return (
    <CustomTable
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      status={data.status === 'Rejected'}
    />
  )
}
